import React from 'react';
import GoogleMapReact from 'google-map-react';
import {isEmpty} from "lodash";
import ReactDOM from "react-dom";
import {MapMarker} from "./MapMarker";

const defaultProps = {
    center: {
        lat: 59.435654,
        lng: 24.738577
    },
    zoom: 10
};

export class Map extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedMarker: null,
            pools: [],
        };

    }


    componentDidMount() {
        fetch('/pools')
            .then((response) => response.json())
            .then((data) => {
                this.setState({ pools: data });
            });
    }

    setSelectedMarker = (index) => {
        this.setState({selectedMarker: index});
    }

    render() {
        return <>
            <div className="h-[500px]">
                <GoogleMapReact
                    bootstrapURLKeys={{key: localStorage.getItem('google_map_api_key')}}
                    defaultCenter={defaultProps.center}
                    defaultZoom={defaultProps.zoom}
                    yesIWantToUseGoogleMapApiInternals={true}
                >
                    {!isEmpty(this.state.pools) && (
                        this.state.pools.map((pool, index) => {
                            if (!pool.lat || !pool.lng) {
                                return null;
                            }

                            return <MapMarker
                                key={index}
                                lat={pool.lat}
                                lng={pool.lng}
                                address={pool.address}
                                name={pool.name}
                                id={pool.id}
                                isSelected={this.state.selectedMarker === index}
                                onMarkerClick={() => this.setSelectedMarker(index)}
                                onCloseTip={() => this.setSelectedMarker(null)}
                            />;
                        })
                    )}
                </GoogleMapReact>
            </div>
        </>;
    }
}


if (document.getElementById('map')) {
    ReactDOM.render(
        <Map/>,
        document.getElementById('map')
    );

    // const root = ReactDOM.createRoot(document.getElementById('map'));
    // root.render(<Map/>);
}
